<template>
  <div>
    <div class="admin_title">{{title}}</div>
    <slot></slot>
    <AdminBar :current="current">
      <slot name="adminbar"></slot>
    </AdminBar>
  </div>
</template>

<script>
import AdminBar from './adminbar'

export default {
  name: 'AdminLayout',
  components: {
    AdminBar,
  },
  data() {
    return {
    }
  },
  props: {
    "title": String,
    "current": Number,
  },
}
</script>

<style scoped lang="scss">
@import '../../../../../assets/css/_vars.scss';

.admin_title {
  z-index: 2;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 3.5em;
  color: $text;
  font-size: $fs_20;
  font-family: $korean_gd_15_r;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/contents/main/admin/controls/adminlayout.vue